import React from 'react';

import { BreadcrumbsItem } from '@atlaskit/breadcrumbs';

import { ComponentLink } from 'src/components/component-link';
import { useIntl } from 'src/hooks/intl';
import Breadcrumbs from 'src/sections/repository/containers/breadcrumbs';

import { useCommitPageUrls } from '../urls';

import messages from './commit-page.i18n';

export const CommitPageBreadcrumbs = (): JSX.Element => {
  const { commitsPageUrl } = useCommitPageUrls();
  const intl = useIntl();

  return (
    <Breadcrumbs>
      <BreadcrumbsItem
        href={commitsPageUrl}
        component={ComponentLink}
        text={intl.formatMessage(messages.commits)}
      />
    </Breadcrumbs>
  );
};
